import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import CustomerService from "../../../Customer/Controller/CustomerController";
import CurrencyService from "../../../Setup/controller/CurrencyController/CurrencyController";
import SaleOrderService from "../../Controller/SaleOrderController";
import { convertCurrency } from "../../../Purchasing/View/PurchaseOrderForms/CurrencyConverter";
export const ShipSaleOrder = (selectedId) => {
    const navigate = useNavigate();
    const fetchSaleOrderDetail = async (selectedId) => {
        try {
            const redirectCallback = () => navigate('/');

            if (selectedId > 0) {
                const saleOrderDetail = await SaleOrderService.GetSaleOrderByID(redirectCallback, selectedId);
                const saleOrder = saleOrderDetail[0];
                return saleOrder;
            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };

    const fetchSaleOrderItems = async (selectedId) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            if (selectedId > 0) {
                const saleOrderDetails = await SaleOrderService.GetSaleOrderItem(redirectCallback, selectedId);

                const saleOrderDetail = await SaleOrderService.GetSaleOrderByID(redirectCallback, selectedId);
                const saleOrder = saleOrderDetail[0];
                const listofCustomers = await CustomerService.GetAllCustomers(redirectCallback);
                const selectedCustomer = listofCustomers.find(customer => customer.ClientCompanyID === parseInt(saleOrder.CustomerID));
                const currencyData = await CurrencyService.GetAllCurrencies(redirectCallback);
                const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
                const ConversionRate = await convertCurrency(listOfCurreny[0].Symbol, selectedCustomer.vc_CurrencySymbol, currencyData, "0");
               

                const selectedPartsData = await Promise.all(saleOrderDetails.map(async (detail) => {
                    const convertedStockPrice = (detail.mon_StockPrice * ConversionRate)
                    const convertedmon_SalesPrice = (detail.mon_SalesPrice * ConversionRate);
                    const convertedvc_UnitOfSale = (detail.vc_UnitOfSale * ConversionRate);
                    const convertednet_SalesPrice = (detail.net_SalesPrice * ConversionRate);
                    const converteddetailnet_VATPrice = (detail.net_VATPrice * ConversionRate);
                    const convertedmon_SellingPrice = (detail.mon_SellingPrice * ConversionRate);
                   
                    return {
                        vc_StockCode: detail.vc_StockCode,
                        PK_SalesOrderItem_ID: detail.PK_SalesOrderItem_ID,
                        vc_Description: detail.vc_Description,
                        mon_StockPrice: convertedStockPrice, // Use the converted price
                        mon_SalesPrice: convertedmon_SalesPrice,
                        vc_UnitOfSale: detail.vc_UnitOfSale,
                        net_SalesPrice: convertednet_SalesPrice,
                        net_VATPrice: converteddetailnet_VATPrice,
                        vc_StockName: detail.vc_Description,
                        PK_Stock_ID: detail.FK_Stock_ID,
                        dec_Discount: detail.dec_Discount,
                        mon_SellingPrice: convertedmon_SellingPrice,
                        dec_Delivered: detail.dec_Delivered,
                        dec_OnOrder: detail.dec_OnOrder,
                        FK_Location_ID_Stock: detail.FK_Location_ID_Stock,
                        vc_Name: detail.DepotName,
                        CUnitOfSale: detail.vc_UnitOfSale,
                        dec_QuantityShipped:detail.dec_QuantityShipped,
                        dec_QtyAllocated:detail.dec_QtyAllocated
                        // Map other fields as needed
                    };
                }));

                return selectedPartsData;
            }
        } catch (error) {
            console.error('Error fetching supplier details:', error);
        }
    };

    const handleShipSaleOrder = async (event, ID) => {
        event.stopPropagation();
        try {
            debugger;
            const redirectCallback = () => navigate('/');
            const lisoffCustomers = await CustomerService.GetAllCustomers(redirectCallback);
            const saleOrderDetail = await fetchSaleOrderDetail(ID);
            const selectedCustomer = lisoffCustomers.find(customer => customer.ClientCompanyID === parseInt(saleOrderDetail.CustomerID));
            const currencyData = await CurrencyService.GetAllCurrencies(redirectCallback);
            const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
            const ConversionRate = await convertCurrency(listOfCurreny[0].Symbol, selectedCustomer.vc_CurrencySymbol, currencyData, "0");
            const SaleOrderItemsList = await fetchSaleOrderItems(ID, selectedCustomer.vc_CurrencySymbol, ConversionRate);
            return SaleOrderItemsList;

        } catch (error) {
            console.error("Error during purchase order process:", error);
        }
    }


    return { handleShipSaleOrder };
};
export default ShipSaleOrder;